import type { AccessGrant, CreateShareInput } from "shared";
import { api } from "./client";

export const sharesApi = {
	listForMap: (mapId: string) =>
		api.get<{ shares: AccessGrant[] }>(`/maps/${mapId}/shares`),
	createForMap: (mapId: string, input: CreateShareInput) =>
		api.post<{ share: AccessGrant }>(`/maps/${mapId}/shares`, input),
	listForLayer: (layerId: string) =>
		api.get<{ shares: AccessGrant[] }>(`/layers/${layerId}/shares`),
	createForLayer: (layerId: string, input: CreateShareInput) =>
		api.post<{ share: AccessGrant }>(`/layers/${layerId}/shares`, input),
	revoke: (grantId: string) => api.del<{ ok: boolean }>(`/shares/${grantId}`),
	rotate: (grantId: string) =>
		api.post<{ share: AccessGrant }>(`/shares/${grantId}/rotate`),
};

export function buildShareUrl(
	mapId: string,
	token: string,
	role: "viewer" | "editor" = "viewer",
): string {
	const path = role === "editor" ? `/k/${mapId}` : `/k/${mapId}/view`;
	const url = new URL(path, window.location.origin);
	url.searchParams.set("t", token);
	return url.toString();
}
